import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DprsPageComponent } from './containers';

const routes: Routes = [
  {
    path: '',
    component: DprsPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DprRoutingModule {}
